import { ArrowForwardIcon } from '@chakra-ui/icons';
import {
  Box,
  IconButton,
  LinkBox,
  LinkOverlay,
  Text,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import ImageHandler from '../../ImageHandler';
import Link from '../../Link';

export interface ActionableImageProps {
  title: string;
  subText: string;
  href: string;
  image: StaticImageDef | React.ReactElement;
  color: 'orange' | 'green' | 'red' | 'yellow' | 'blue';
}

const ActionableImage: React.FC<ActionableImageProps> = ({
  color,
  href,
  image,
  subText,
  title,
}) => {
  const styles = useMultiStyleConfig('ActionableImage', { color });
  return (
    <LinkBox>
      <Box __css={styles.container} role="group">
        <ImageHandler image={image} />
        <Box __css={styles.titleBox}>
          <Text sx={styles.titleBoxText}>{title}</Text>
        </Box>

        <Box __css={styles.overlay}>
          <Box>
            <Text sx={styles.overlayTitle}>{title}</Text>
            <Text sx={styles.overlaySubtext}>{subText}</Text>
            <LinkOverlay
              as={Link}
              to={href}
              variant="plain"
              isExternal={isExternalLink(href)}
            >
              <IconButton
                variant="outline"
                color="white"
                aria-label={title}
                __css={styles.overlayButton}
                icon={<ArrowForwardIcon />}
              />
            </LinkOverlay>
          </Box>
        </Box>
      </Box>
    </LinkBox>
  );
};

export default ActionableImage;
